import type { ServiceAnswer } from '@acs/shared';
import { useI18n } from '../../i18n/index.js';

/**
 * The questions asked before booking and the customer's answers (doc 64), as
 * they were when the booking was made — from the appointment's own snapshot,
 * never from today's services, so editing or removing a service cannot change
 * what the owner reads here. Read-only; plain text (never HTML), long answers
 * wrap and keep their line breaks. Nothing at all for a booking without
 * answers: an older booking is not "incomplete".
 */
export function AppointmentServiceAnswers({ answers }: { answers: readonly ServiceAnswer[] | undefined }) {
  const { t } = useI18n();
  if (!answers || answers.length === 0) return null;
  return (
    <section className="appt-answers" aria-label={t('booking.serviceAnswers')}>
      <h3 className="appt-answers__title">{t('booking.serviceAnswers')}</h3>
      <dl className="appt-answers__list">
        {answers.map((a) => (
          <div key={a.questionId} className="appt-answers__item">
            <dt>{a.question}</dt>
            <dd>{a.answer}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
